<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Acolhimentos") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Acolhimentos"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1">
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/home'"
            :disabled="$route.name == 'relatorios_home_acolhimentos'"
          >
            Todas as Unidades de Acolhimento
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/graficos'"
            :disabled="$route.name == 'graficos_acolhimentos'"
          >
            Gráficos de Unidades de Acolhimento
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/crianca/home'"
            :disabled="$route.name == 'relatorios_acolhimentos_criancas'"
          >
            Acolhimento de Crianças e Adolescentes
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/crianca/graficos'"
            :disabled="$route.name == 'graficos_acolhimentos_criancas'"
          >
            Gráficos Acolhimento de Crianças e Adolescentes
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/idoso/home'"
            :disabled="$route.name == 'relatorios_acolhimentos_idosos'"
          >
            Acolhimento de Pessoas Idosas
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/acolhimentos/idoso/graficos'"
            :disabled="$route.name == 'graficos_acolhimentos_idosos'"
          >
            Gráficos Acolhimento de de Pessoas Idosas
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsAcolhimentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Acolhimentos"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
